export const SDK_VERSION = '4.787.15';